export const main = {
	yhxm:'사용자 이름',
	qrxx:'정보 기입 확인',
    mmdl:'비밀번호 로그인',
    yzmdl:'인증번호 로그인',
    sjhm:"휴대폰 번호",
    qsrmm:'비밀번호를 입력하십시오.',
    wjmm:'비밀번호 분실',
    dl:'로그인',
    zcxzh:'새 계정 등록',
    yzm:'인증 번호',
    hqyzm:'인증 번호 가져오기',
    sryx:'사서함 입력',
    zcsrmm:'비밀번호 다시 입력',
    yqm:'초대 코드/초대인 핸드폰 번호를 입력하세요',
    sjyz:'휴대폰 인증',
    yxyz:'사서함 인증',
    tyxyhzc:'사용자 계약 및 개인 정보 보호 정책에 동의합니다.',
    ty:'읽었고 동의합니다.',
    yhxy:'사용자 프로토콜',
    yszc:'개인 정보 보호 정책',
    zce:'등록',
    zyzhljdl:'계정이 이미 있습니다. 지금 로그인하십시오.',
    wdzc:'내 자산',
    wdzh:'내 계정',
    tbgl:'동기식 관리',
    fbxh:'신호 게시',
    xhsc:'신호시장',
    czsc:'운영 매뉴얼',
    tcxh:'퇴출 신호',
    ye:'잔고',
    jz:'순가치',
    jyss:'거래건수',
    ccyl:'보유이익',
    xvh:'순번',
    sftb:'동기화 여부',
    fwq:'서버',
    zh:'계정',
    zyk:'총손익',
    kds:'청구수',
    zhzt:'계정 상태',
    cz:'작업',
    s:'예',
    f:'아니오',
    zc:'정상',
    yc:'예외',
    ck:'보기',
    cpyk:'제품의 손익',
    zss:'총건수',
    jypz:'교역 품목',
    sy:'수익',
    sszb:'건수가 차지하는 비율',
    cczh:'매수 포지션 총람',
    ddh:'주문 번호',
    jyl:'거래량',
    kcsj:'개시 시간',
    kcjg:'개시 가격',
    bjjg:'가격 표시',
    zyzs:'익절/손절',
    gylx:'익일이자',
    yk:'손익',
    xzcksj:'계정에서 보려는 데이터를 선택하십시오.',
    tbyk:'동시 손익',
    ccsj:'보유 시간',
    pcsj:'스퀘어 시간',
    tjzh:'계정 추가',
    bz:'비고',
    sfwxh:'신호인지 여부',
    tbzt:'동기화 상태',
    ytb:'동기화됨',
    wtb:'동기화되지 않음',
    qyjy:'사용/사용 금지',
    yqy:'사용됨',
    yjy:'사용 금지 ',
    xgzhmm:'계정 비밀번호 수정',
    gbxh:'신호 차단 ',
    sczh:'계정 삭제',
    qw:'이동',
    y:'페이지',
    tjglzh:'연결된 계정 추가',
    qxz:'선택하십시오',
    qsrzh:'계좌번호를 입력하십시오.',
    mm:'비밀번호',
    qsrbz:'비고를 입력하십시오.',
    sjsqxhts:'실제 계정 마스터 비밀번호 인증은 커뮤니티 시그널로 승격될수 있습니다.',
    qr:'확인',
    qx:'취소',
    zhjy:'계정 *****가 사용금지상태로 설정되었는지 여부',
    zhqy:'계정 *****가 사용되었는지 여부',
    dqdlmm:'현재 로그인 비밀번호',
    xzhmm:'새 계정 비밀번호',
    qrxmm:'새 비밀번호 확인',
    qsrdqdlmm:'현재 로그인 비밀번호를 입력하십시오.',
    qsrxmm:'새 비밀번호를 입력하십시오.',
    qzcsrxmm:'새 비밀번호를 다시 입력하십시오.',
    yhzl:'사용자 프로필',
    jcxx:'기본 정보',
    tx:'프로필사진',
    sczp:'사진 업로드',
    tudxxz:'업로드할 사진을 선택하십시요. 크기는 413*626픽셀, JPG, PNG 등의 포맷을 지원하며 사진은 2M 미만이어야 합니다.',
    gjhdq:'국가 및 지역',
    dzyx:'전자 사서함',
    bcxg:'변경사항 저장',
    zhaq:'계정 보안',
    dqmm:'현재 비밀번호',
    xmm:'새 비밀번호',
    qrmm:'비밀번호 확인',
    qsrdqmm:'현재 비밀번호를 입력하십시오.',
    qd:'확인',
    tjtb:'동기화 추가',
    tb:'동기화',
    xh:'신호',
    qsrnr:'내용을 입력하십시오.',
    tbzh:'계정 동기화',
    qxztbzh:'동기화 계정 다중 선택을 선택하십시오.',
    jygz:'거래 규칙',
    bzjdb:'보증금 등비',
    jzdb:'순가치 등비',
    kyzjdb:'가용 자금 등비',
    jyldb:'거래량 등비',
    gdssdb:'고정 건수 등비',
    jycs:'거래 매개 변수',
    kcjybc:'개시 가격 우대 보상',
    xhsxzdpc:'신호 고장 자동 스퀘어',
    zdss:'최대 건수',
    zdhc:'최대 회수',
    jsbz:'모두 국제표준계약을 표준통화로 계산하여 국제표준에 대한 계약 100,000 금 국제표준계약 100 온스 은 국제표준계약 5,000 온스 원유 국제표준계약 1,000 배럴)',
    pctbts:'일부 스퀘어 및 스퀘어가 작동하는 것은 플랫폼 터미널에 따라 작동하는 규칙이 다르기 때문에 동기화 과정이 일시적으로 지원되지 않음을 알고 계십시오.',
    tbxh:'동기화 신호',
    tbms:'동기화 모드',
    tbxs:'동기화 계수',
    tbsz:'동기화 설정',
    xgcs:'매개변수 수정',
    yzttb:'동기화 일시 정지됨',
    ykqtb:'동기화 사용됨',
    sctb:'동기화 삭제',
    xgtbcs:'동기화 매개변수 수정',
    cgtbzt:'동기화 상태 수정',
    sfqkzhdtb:'현재 계정 *******의 동기화 작업을 사용할지 여부',
    sfztzhdtb:'현재 계정 *******의 동기화 작업을 일시 정지할지 여부',
    tjxh:'신호 추가',
    nsyl:'연간 수익률',
    zt:'상태',
    dyz:'동기화자',
    kstbsj:'동기화 시작 시간',
    zwsj:' 데이터 일시 없음',
    xzzh:'계정 선택',
    qxzzh:'계정을 선택하십시오.',
    qqdxhhtbzzt:'무한 순환 위험을 방지하기 위해 신호 및 동기화 사용자의 현재 상태를 파악하십시오.',
    xhm:'신호 이름',
    qsrxhm:'신호 이름을 최대 15자까지 입력하십시오.',
    xhmts:'신호 이름은 계정당 하나의 신호 이름에 대응하며, 일단 확인되면 변경할 수 없습니다.',
    gszzdjz:'추종자 최저순가치',
    sfgkxh:'신호 공개 여부',
    gk:'공개',
    sm:'사적',
    gsddzs:'주문 노트 따르기',
    gsddzsts:'여기에 기입한 내용은 모든 추종자의 MT 주문 노트에 표시됩니다.',
    jdzyjgyhkf:'전문/기관 사용자만 사용 가능',
    xhms:'신호 설명',
    sl:'예시: 이 계정 주로 주인은 단선, 일중 주문, 단일 고정 및 손실정지, 2000달러 손수 1:1 동기화할것을 조언합니다.',
    clmsts:'모든 사용자의 개인 정보를 보호하기 위해 전략 설명에 연락처를 포함할 수 없습니다.',
    xhlb:'신호 목록',
    xhlbts:'참고 페이지 데이터는 신호원의제3자 계정에서 가져옵니다. 데이터 통계는 지연되거나 불확실할 수 있습니다. 데이터는 참조용이며 실제로 얻을 수 있는 이익을 나타내지 않습니다.',
    xhy:'신호원',
    zongsyl:'총 수익률',
    zhousyl:'주간 수익률',
    jqtjycs:'최근 7일간 거래건수',
    irrqzsy:'IRR 가중치 이익',
    zdhc2:'최대 회수%',
    zq:'기간(일)',
    jbsj:'기본 데이터',
    fx:'공유',
    sc:'컬렉션',
    ysc:'이미 저장',
    zsy:'총수익',
    zrj:'총입금',
    zcj:'총출금',
    zdhcl:'최대 회수 비율 값',
    zdfk:'최대 부실 손실',
    zdds:'총 주문 수',
    dbzdjyl:'건당 최대 거래량',
    t:'일',
    zhhbdw:'계정 화폐 단위',
    ckqb:'모두 보기',
    anyue:'월별',
    jidu:'분기',
    bannian:'반년',
    yinian:'1년',
    ernian:'2년',
    sanian:'3년',
    jzye:'순/잔액 $',
    crj:'출입금$',
    cj:'출금',
    rj:'입금入金',
    ysyl:'월간 수익률',
    yiyue:'1월',
    eryue:'2월',
    sanyue:'3월',
    siyue:'4월',
    wuyue:'5월',
    liuyue:'6월',
    qiyue:'7월',
    bayue:'8월',
    jiuyue:'9월',
    shiyue:'10월',
    shiyiyue:'11월',
    shieryue:'12월',
    ccxj:'보유 세부 정보',
    cq:'제품',
    dk:'다중/비어 있음',
    ss:'건수',
    yk2:'익/손 ',
    hlzb:'측정 지표',
    ylddcxsjpj:'평균 수익 주문 기간',
    ksddcxsjpj:'평균 손실 주문 기간',
    dgddylpj:'평균 단일 주문  이익',
    dgddkspj:'평균 단일 주문 손실',
    dgddlrzd:'최대 단일 주문 이익',
    dgddkszd:'최대 단일 주문 손실',
    syl:'수익률',
    sjbl:'데이터 비율',
    sl:'승률',
    zdjybl:'자동 거래 비율',
    pcddmx:'스퀘어 주문 상세내역',
    pcjg:'스퀘어가격',
    sxf:'수속료',
    tbxtccsc:'동기화 시스템 운영 설명서',
    zhzc:'계정 등록',
    xtdl:'시스템 로그인',
    jzhszwxh:'계정을 신호로 설정 여부?',
    sztbxh:'동기화 신호 설정', 
    wzjs:"JCLH는 최종 사용자에게 데이터 컨버전스와 정보 공유를 제공하는 관리 플랫폼입니다. 사용자는 JCLH 관리를 통해 계정 재무 및 리스크를 분석 및 요약할 수 있습니다. JCLH 동기화 시스템은 사용자에게 여러 계정 간의 동기화 관계를 관리할 수 있는 서비스를 제공합니다. JCLH는 거래/플랫폼 업체가 아니며, 어떠한 금융기관과도 이익, 알선&중개 관계를 맺고 있지 않습니다.",
    mzsmText:`<p style="line-height: normal; text-align: left; text-indent: 0em;">
    <span style="font-size: 12px; color: rgb(255, 255, 255);"></span>
</p>
<p style="text-align: center; line-height: normal; text-indent: 0em;">
    <span style="font-size: 22px; color: rgb(255, 255, 255);">
		<span style="font-size: 22px; color: rgb(255, 255, 255); font-family: Batang, serif;">면</span>
		<span style="font-size: 20px; color: rgb(255, 255, 255); font-family: Batang, serif;"> </span>
		<span style="font-size: 20px; color: rgb(255, 255, 255); font-family: Batang, serif;">책</span>
		<span style="font-size: 20px; color: rgb(255, 255, 255); font-family: Batang, serif;"> </span>
		<span style="font-size: 20px; color: rgb(255, 255, 255); font-family: Batang, serif;">성</span>
		<span style="font-size: 20px; color: rgb(255, 255, 255); font-family: Batang, serif;"> </span>
		<span style="font-size: 20px; color: rgb(255, 255, 255); font-family: Batang, serif;">명</span>
	</span>
</p>
<p style="line-height: normal; text-align: left; text-indent: 0em;">
    <span style="font-size: 12px; font-family: Batang, serif; color: rgb(255, 255, 255);">본 성명은 JCLH가 </span>
	<span style="font-family: Batang, serif; font-size: 12px; color: rgb(255, 255, 255);">www.JCLH.biz</span>
	<span style="font-size: 12px; font-family: Batang, serif; color: rgb(255, 255, 255);">에 등록 및 명시적으로 본 약관에 동의하는 개인 또는 회사와 함께 공동 서명합니다.</span>
</p>
<p style="line-height: normal; text-align: left; text-indent: 0em;">
    <span style="font-size: 12px; color: rgb(255, 255, 255);">
		<span style="color: rgb(255, 255, 255); font-size: 12px; font-family: Batang, serif;"> 본 사이트는 정보를 확인하기 위해 신중한 조치를 취했지만 포함된 정보가 모두 정확하다는 보장은 없습니다. </span>
		<span style="color: rgb(255, 255, 255); font-size: 12px; font-family: &quot;Malgun Gothic&quot;, sans-serif;">우리</span>
		<span style="color: rgb(255, 255, 255); font-size: 12px; font-family: Batang, serif;">의 정보가 전면적이지 않거나 누락되거나 지연될수 있슴을 이해해 주시기 바랍니다. 본 사이트 또는 독립정보제공자는 정보의 오류, 불완전, 지체, 부정확성 또는 본 사이트의 정보에 대한 의존을 바탕으로 발생한 어떠한 손해에 대해서도 책임을 지지 않습니다. 향후 환율변동에 대한 예측과 같은 모든 예측이나 관점 및 이러한 예측에 기반한 거래활동은 제3자의 개인적인 견해 및 행위를 나타낼 뿐 본 사이트의 입장을 나타내지는 않습니다. 제3자의 예측은 어떠한 형태의 실적 약속도 나타내지 않는다는 점을 이해해야 하며 직접 또는 간접적으로 따르지 말아야 합니다. 투자판단을 위해서는 독립적인 분석을 수행해야 하며 본 사이트의 내용을 기반으로 판단에 따른 투장행위로 인해 실제 이익이나 손실이 발생할수 있음을 이해해야 합니다. 귀하가 본 사이트에서 제공하는 거래 전략과 신호에 기반하여 개인 구성거래 시스템을 운용하여 행한 투자행위는 귀하의 결정에 따른 것이며 모든 위험을 감수해야 합니다.</span>
	</span>
</p>
<p style="line-height: normal; text-align: left; text-indent: 0em;">
    <span style="font-size: 12px; font-family: Batang, serif; color: rgb(255, 255, 255);"> 본 사이트는 본 사이트의 관리 플랫폼이 고위험 투자에 대해 어느 정도 알고 있는 이용자에게만 적용됨을 분명히 밝히고 있습니다. 일상생활의 지출에 지장을 주지 않으면서 여유있는 자금으로 투자하여야 합니다. 어떤 거래 전략도 과거에 달성한 실적이 향후 성과를 나타낼수 없습니다. 일반적으로 미래의 환율변동은 예측할수 없으며 이는 어떠한 개인전략, 금융 컨설턴트, 수동 또는 자동 거래 시스템도 어떠한 형태의 예측으로도 이익이 발생할수 있다는것을 보장할수 없음을 나타내기 때문에 투자 예측에 대하여는 반드시 자신의 분석을 통해 판단하고 맹종하는 것은 금물입니다.</span>
</p>
<p style="line-height: normal; text-align: left; text-indent: 0em;">
    <span style="font-size: 12px; font-family: Batang, serif; color: rgb(255, 255, 255);"> 웹 사이트 또는 네트워크 전송이 지연될 경우 데이터 편차가 발생할수 있으며 신호제공 계정의 비밀번호 수정 또는 기타 네트워크 원인으로 인한 계정 끊김으로 인해 주문 추종 관계가 손실될수 있는것을 포함하지만 이에 국한되지 않기 때문에 사용자는 동기화 시스템을 사용한 후 즉시 다중계정관리 시스템의 데이터 변화를 확인해야 합니다. JCLH 또는 본 사이트의 어떤 파트너도 JCLH에서 제공하는 정보를 기반으로 하고 개인설정 동기화 시스템을 사용하여 투자하면 수익이 발생한다고 보장할수 없습니다. 이외에도JCLH는 동기화 시스템의 개발자로서 이 서비스의 제공자 회사나 거래처와 같은 제3자의 지연, 부주의로 인한 고객의 손실에 대해 어떠한 책임도 지지 않습니다. 이상과 더불어JCLH는 트레이더가 제공하는 전략 및 거래 신호에 대해 어떠한 책임도 지지 않음 분명히 밝힙니다. </span>
</p>
<p style="line-height: normal; text-align: left; text-indent: 0em;">
    <span style="font-size: 12px; font-family: Batang, serif; color: rgb(255, 255, 255);">JCLH 소속회사의 등록 소재지에 관한 법령 및 규정은 다른 관할 법률이 적용하도록 지정되어 있지 않는 한 본 성명과 본 성명을 관할하는 당사자간에 야기되는 분쟁에 적용됩니다. </span>
</p>
<p style="line-height: normal; text-align: left; text-indent: 0em;">
    <span style="font-size: 12px; font-family: Batang, serif; color: rgb(255, 255, 255);">계약당사자가 본 성명에 따른 권리의 실현을 모색하거나 본 성명에 따른 권리나 의무의 선고를 모색하는 민사소송 또는 그 밖의 소송 과정에서 개별 계약당사자는 변호사를 대리하기 위한 비용과 지출을 부담해야 합니다. 계약자는 전속 관할과 법원 재판지를 인정합니다. </span>
</p>
<p style="line-height: normal; text-align: left; text-indent: 0em;">
    <span style="font-size: 12px; font-family: Batang, serif; color: rgb(255, 255, 255);">본 성명의 해석 언어는 중국어여야 합니다.</span>
</p>
<p style="line-height: normal; text-align: left; text-indent: 0em;">
    <span style="font-size: 12px; font-family: Batang, serif; color: rgb(255, 255, 255);">만약 문서, 정보 및 메시지의 비 중국어 표현과 중국어 표현사이에 모순과 불일치가 발생하는 경우 양측은 중국어 문서, 정보 및 메시지를 기준으로 합니다.</span>
</p>
<p>
    <br/><br/>
</p>`,
    yszcText:`<p style="font-weight: bold; color: windowtext; text-align: center; ">
    <strong>
        <span style="color: #ffffff; font-family: 微软雅黑; font-size: 22px;">
            隐私政策
        </span>
    </strong>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">感谢您使用 JCLH ！</span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        本《隐私政策》说明了我们如何收集、使用、处理和披露您的信息,包括与您访问和使用 JCLH 的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果本《隐私政策》中有未定义的术语（如“服务项目”或“ JCLH ”），其定义和我们在服务条款中的定义一致。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在本政策中，“ JCLH ”、“我们”或“我们的”指本《隐私政策》下对您的信息负责的 JCLH 公司。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1. 我们收集的信息类型
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        我们主要收集三类信息。
    </span>
</p>

<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        1.1 您向我们提供的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        使用 JCLH 的必要信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">

        当您使用 JCLH 时，我们要求您提供并收集以下您的个人信息。此等信息对于充分履行您和我们之间的合同很有必要，并使得我们能够遵守我们的法律义务。没有此等信息，我们可能无法向您提供您所要求的全部服务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.1.1 账号信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在您注册 JCLH 账号时，我们要求您提供用户昵称、手机号码、电子邮件地址、密码、头像等信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.1.2 您选择向我们提供的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以选择向我们提供额外的个人信息，以便在使用 JCLH 时获得更好的用户体验。此等额外信息将基于您的自愿同意而处理。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        额外个人资料信息。您可选择提供额外个人资料信息，作为您个人资料的一部分（例如首选语言、国家和地区及个人描述）。如您在账号设置中所示，部分此等个人信息是您公开个人资料页的一部分，将向其他人公开。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        交易风控信息。您可选择提供设置账户交易时使用的风控策略。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        其他信息。您还可以选择在填写表格、进行搜索、更新或添加 JCLH 账号信息或使用 JCLH 的其他功能时，向我们提供其他信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.2 您使用 JCLH 时，我们自动收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        在您使用 JCLH 时，我们会自动收集关于您所使用的服务以及如何使用相关服务的信息，包括个人信息。 基于我们合法的利益理由以提供和改进 JCLH ，此等信息对于充分履行您和我们之间的合同很有必要，使得我们能够遵守法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        登录数据和设备信息。即使您未创建或登录 JCLH 账号，当您访问并使用 JCLH 时，我们也会自动收集登录数据和设备信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        Cookies 及类似技术。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        Log-In Cookies : 当您使用“在此计算机自动登录”的功能时，我们会使用持久 Cookies 。在这种情况下， Cookies 文件将永久的保存在您的计算机硬盘上，除非您使用浏览器或操作系统软件手工将其删除。当您再次使用该网站时，网站就会通过读取这些 Cookies，得知您的相关信息，就可以做出自动登录的动作。这些 Cookies 包含一个 ID 号。您的登录资料和您的密码不会被保存。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        1.3 我们通过第三方收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        第三方平台的交易账户信息。如果您将第三方交易账户连接至 JCLH，您将授权 JCLH 获取您的第三方平台的交易账户相关信息（比如：交易商信息、账户名、只读密码、交易数据等）。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        2.我们如何使用所收集的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们使用、存储和处理您的信息（包括个人信息），以提供、了解、改进和发展 JCLH ，创建和维护一个受到信任的、更安全的环境，并遵守我们的法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        2.1 创建和维护一个受到信任的以及更安全的环境
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        检测和预防欺诈、滥用、安全事件及其他有害活动。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        开展安全调查和风险评估。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        对照数据库与其他信息源进行检查，包括在适用法律允许的限度内以及必要时经您同意进行背景或警方调查。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        遵守我们的法律义务。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        解决我们与任何会员之间的任何争议，并执行我们与第三方的约定。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        执行我们的服务条款及其他政策。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.分享与披露
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.1 征得您的同意
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        经您同意，我们可以按照您在同意时的指示分享您的信息（包括个人信息），如当您授权第三方应用软件或网站访问您的 JCLH 账号时。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.2 业务转移
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果 JCLH 从事或涉及任何合并、收购、重组、资产出售、破产或者资不抵债的事件，那么我们可以出售、转让或分享我们的部分或全部资产，包括与此类交易或设想的此类交易(如尽职调查)有关的您的信息。在此情况下，我们会在转移您的个人信息且令其遵守不同隐私政策之前通知您。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        3.3汇总信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        出于遵守法规、行业与市场分析、受众统计归类、营销与广告以及其他业务目的，我们也会分享汇总信息（关于我们用户的合并信息，此类信息不再识别或指向某位个人用户）和其他匿名信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        4.其他重要信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        4.1 关联第三方账号
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您通过关联账号向我们提供的一些信息可能会被存储、处理和传输，用于欺诈防范和风险评估；以及对于您通过此类链接向 JCLH 提供的信息，其发布与显示取决于您在 JCLH 和第三方网站上的设置与授权。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.您的权利
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以联系我们，在相关 JCLH 数据控制人适用之前行使本条所述的任何权利。请注意，在对您的请求采取进一步行动之前，我们可能会要求您验证您的身份。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.1 管理您的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以通过您的账号设置访问和更新您的一些信息。您有责任及时更新您的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.2 不准确或不完整的信息
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您有权要求我们更正您的不准确或不完整的个人信息（以及您无法在您的 JCLH 账号中自行更新的信息）。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        5.4 数据保留与删除
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        您可以向官方客服申请注销帐号或删除账户信息,工作人员会在3个工作日内处理。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        通常，我们只在履行您与我们之间的合同并遵守我们的法律义务的必要时间段内保留您的个人信息。如果您不再希望我们使用您的信息来为您提供 JCLH ，您可以要求我们删除您的个人信息并关闭您的 JCLH 账号。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        请注意，如果您申请删除您的个人信息：
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们可能会保留您的一些个人信息，以符合我们的合法商业利益，如欺诈侦测和预防以及提高安全性。例如，如果我们因欺诈或安全原因停用了 JCLH 账号，则我们可能会保留该 JCLH 账号的某些信息，以防止该会员将来再次创建新的 JCLH 账号。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        为了遵守我们的法律义务，我们可能会保留并使用您的个人信息。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        即使您的 JCLH 账号被注销，您与他人分享的信息仍可以在 JCLH 上公开显示。但您对这些信息的归属信息将被删除。此外，您的信息的某些副本（如登录记录）可能会保留在我们的数据库中，但会与个人标识符区分开来。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        6. 全球运营
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        为方便我们的全球运营， JCLH 可在我们的公司内部或与服务提供商转移、存储和处理您的信息。这些国家/地区的法律或许与您居住地所适用的法律不同。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        7.安全
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        我们将持续实施和更新管理、技术和物理安全措施，保护您的信息不受未经授权的访问、损失、破坏或变更。我们用来保护您的信息的一些安全措施是防火墙和数据加密以及信息访问控制。如果您知道或有理由相信您的 JCLH 账号信息已丢失、被盗用、被挪用或遭到其他方式入侵，或者出现任何实际或怀疑盗用您的 JCLH 账号的情况，请按照以下“联系我们”一条的说明联系我们。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        8.本《隐私政策》的变更
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        JCLH 保留随时根据本条规定修改本《隐私政策》的权利。如果我们对本《隐私政策》做出变更，我们将在 JCLH 上发布变更后的《隐私政策》，并更新《隐私政策》顶端的“最后更新”日期。如果您不同意变更后的《隐私政策》，您可以注销您的账号。如果您未在变更后的《隐私政策》生效前注销您的账号，您对 JCLH 的继续访问或使用将受变更后的《隐私政策》的约束。
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        9.联系我们
    </span>
</p>
<p style=" color: windowtext; text-align: left; ">
    <span style="color: #ffffff; font-family: 微软雅黑; font-size: 12px;">
        如果您对本《隐私政策》或 JCLH 的信息处理方法有任何问题或意见，您可以通过官网在线客服与我们联系，或通过 JCLH 官方提供的各种联系方式与我们联系， JCLH 将给予您帮助。
    </span>
</p>
`,
fwtkText:`<h1 style="text-align: center; line-height: normal; text-indent: 0em;">
<span style="font-size: 22px;"><strong><span style="color: rgb(255, 255, 255); font-family: 微软雅黑;">服务条款</span></strong></span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;"><span>欢迎您使用</span> JCLH 网站的服务。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您应当阅读并遵守《 JCLH 服务条款》(以下简称“本协议”)，请您务必审慎阅读、充分理解各项条款内容。除非您已充分阅读、完全理解并接受本所有条款内容，否则您无权使用 JCLH 服务。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">本协议是由 JCLH 与在网站 www.JCLH.biz 上的已注册登记并已明确接受此等条款和条件的个人或公司共同签署。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH多账户管理系统可以让您实现在云端管理多平台。用户可以通过JCLH管理、分析和汇总账户财务和风险。系统允许用户通过“Copy-Trading”的方式进行跨平台订单复制。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">JCLH不是不是经纪商或交易商，也不与任何金融机构有利益、介绍或居间关系。公司专注服务被传统金融市场忽略的一大部分客户：中小企业，个人客户。我们通过技术，让资产集合、风险管理、多账户管理、策略开发成为容易上手的业务。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">风险协议</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.考虑到交易存在巨大的风险，建议您在开户及交易前充分了解相关法律条规及咨询专业意见，根据个人的财务状况、投资经验、风险偏好等相关因素，慎重选择适合您的保证金交易产品。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 网站上所有信息（含文字、图片、音频、视频）均出于为公众传播有益资讯信息之目的，并不意味着 JCLH 赞同其观点或构成投资建议，且 JCLH 不会向您提供任何可依赖的投资建议。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.投资市场存在的风险是不受 JCLH 控制或影响的，您所有的交易均由个人承担风险。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">业绩统计服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您应当理解，实际投资交易的收益/亏损百分比会随着各项因素而发生变化，如初始账户余额、市场行为、跟随者的账户设置等。因此，您在进行投资过程中实际产生的收益/亏损百分比可能与JCLH 多账户管理平台中信号提供者收益/亏损百分比存在一定的差异。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2. JCLH 不保证您所使用的信号提供者信号或本网站所传播的信息能让您获得利润而不亏损，您在 JCLH 多账户管理平台上进行保证金投资的实际收益/亏损均由您本人承担， JCLH 不承担任何相关责任。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">网上风险服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.您理解并同意，使用互联网的交易服务存在一些风险，包括硬件、软件或互联网连接等不可控因素，如信号强度、互联网的接收或路径、设备硬件或软件配置、或互联网连接的可靠性等不可控。 JCLH 不对网络交易中出现的通讯故障、误传或延误造成的损失负任何责任。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.贵金属等全球金融产品投资市场的波动性或非流动性可能阻碍委托以有利的价格执行，或根本无法执行。如因市场情况或您的交易商的过错而导致交易无法执行，从而造成的任何损失、损害、成本或费用</span>(<span>包括但不限于，利润损失、使用损失、直接、间接、偶发或结果性损害</span>)<span>，</span> JCLH <span>不承担任何责任。</span></span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">外部链接服务</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">您理解并同意，通过 JCLH 网站链接到其他某些网站仅出于便利而提供。因这些网站所含的信息资料不可控制， JCLH 不对这些网站或您在这些网站找到的资料作出任何承诺。 JCLH 通往这些网站的链接信息，并不构成任何类型的认可或建议。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">适用法律和管辖权</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">1.JCLH所属公司注册所在地法律、法规应适用于本协议以及管辖本协议各方之间引起的争议，除非存在法律指定适用其他管辖法律。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">2.在合约一方寻求实现本协议下的权利，或寻求宣告本协议下的任何权利或义务的任何民事诉讼或其他诉讼过程中，各合约方应承担其代理律师的费用和支出。合约方认可专属管辖和法院审判地。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">3.本协议的解释语言应为（简体）中文。</span>
</p>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">4.如果任何文件、信息和消息的非中文表述和中文表述之间出现矛盾和不一致的情况下，双方将以中文文件、信息和消息为标准。</span>
</p>
<h1 style="margin: 10px 0px; text-align: left; line-height: normal; text-indent: 0em;">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">其他</span>
</h1>
<p  style=" color: #ffffff; text-align: left; ">
<span style="color:#ffffff; font-family: 微软雅黑; font-size: 12px;">如果您对本条款有意见或建议，可与 JCLH 客服联系， JCLH 将给予您帮助。</span>
</p>
<p>
<br/>
</p>`,
    mzsmbt:"면  책  성  명",
	mzsmbt:"면책 조항",
	qwzxcz:"계정 주문 수익을 보장하기 위해 스스로 조작하지 마십시오!",
	wdzl: "내 자료",
	wdqb: "내 지갑",
	hyfw: "회원 서비스",
	wdtd: "내 팀",
	tcdl:"로그인 종료",
	xhgl: "신호 관리",
	sfgz:"요금 규칙: 자금 및 신호 자금 1: 1을 기반으로 가격 책정;사용자 구독료 동적 업데이트, 일별 공제.",
	jcdyf:"기본 구독료",
	yhdyf: "사용자 구독료",
	zhye: "계좌 잔액",
	xhye: "신호 잔액",
	yf: "월",
	bkxzjygz: "현재 거래 규칙 선택 불가",
	bksrjycs: "현재 거래 매개 변수를 입력할 수 없습니다",
	hand: "손",
	pcjl: "창고 정리",
	tdxx: "팀 정보",
	wdyqm: "내 초대 코드",
	fz: "복제",
	yqmsjh:"초대 코드/핸드폰 번호 추천",
	bangd: "바인딩",
	agree: "동의합니다",
	mzsm:"면책 조항",
	and: "및",
	fwtk: "서비스 약관",
	qhyy: "언어 전환",
	zhong: "중국어",
	ying: "영어",
	wei: "위구어",
	tai: "태국어",
	han: "한국어",
	ri: "일본어",
		
	kyye: "사용 가능한 JCLHoin 잔액",
	yets: "JCLHoin은 JCLH 커뮤니티에서만 사용할 수 있는 토큰이며 사용자 간에 양도하거나 환매할 수 없습니다.JCLH가 운영하고 있습니다.구매 포인트를 교환하여 얻을 수 있습니다.JCLHoin은 구독료 지불, 경품 교환 및 기타 역내 행위에 사용할 수 있습니다.자세한 내용은 <JCLHoin 구매 및 사용 계약>을 참조하십시오.",
	zffs: "지불 방법",
		
	szhb: "디지털 화폐",
	wxzf:"위챗 지불",
	zfb: "알리페이",
	yl:"은련",
	xyk: "신용카드",
	szjl:"수지 기록",
		
	szsj:"시간",
	szsl: "수량",
	szxm: "프로젝트",
	szzt: "주문 상태",
	szbh: "주문 번호",
		
	dqdj:"현재 레벨",
	yxq: "최대 유효 기간",
	shengj: "업그레이드",
	hygm: "JCLH 회원 구매를 환영합니다",
	zfje: "지불 금액",
	xfjl: "소비 기록",
	xfje: "금액",
	dzgl: "관련",
	dzg: "개",
	dzzh: "계좌",
	
	a1:'구매 수량',
	a2:'회원 등급',
	a3:'계정 수량',
	a4:'조작',
	a5:'업로드할 증빙서류',
	a6:'결제 성공',
	a7:'결제 실패',
	a8:'증빙서류 업로드',
	a9:'결제 확인',
	a10:'결제',
	a11:'디지털 화폐',
	a12:'지갑 주소',
	a13:'주소 복사',
	a14:'결제를 위해 지갑 주소 복사',
	a15:'QR 코드',
	a16:'금액',
	a17:'확인',
	a18:'취소',
	a19:'닫기',
	a20:'복사 성공',
	a21:'증빙서류 업로드',
	a22:'증빙서류 확인',
	a23:'검토 대기',
	
	a24:'보증금 비율',
	a25:'순가치 비율',
	a26:'사용 가능 자금 비율',
	a27:'거래량 비율',
	a28:'고정 로트 수 비율',
	a29:'역방향 카피 트레이딩',
	a30:'포지션 오픈 보상',
	a31:'포지션 클로즈 보상',
	a32:'선택됨',
	a33:'현재 계정 사용 여부',
	a34:'현재 계정 일시 중지 여부',
	a35:'동기화 작업',
	a36:'한 개의 계정으로 제한',
	a37:'구매한 계정 수량에 제한 없음',
	
	a38:'시용 버전 회원',
	a39:'기본 버전 회원',
	a40:'프로페셔널 버전 회원',
	a41:'기관 버전 회원',
	a42:'휴대폰 번호를 설정해 주세요',
	a43:'이메일을 설정해 주세요',
	a44:'초대 코드를 입력해 주세요',
	a45:'업로드한 아바타 이미지는 JPG 형식만 가능합니다!',
	a46:'업로드한 아바타 이미지 크기는 2MB를 넘을 수 없습니다!',
	a47:'동기화 데이터가 없습니다',
	a48:'총 롯 수',
	a49:'그것을 ~로 설정할지 여부',
	a50:'활성화',
	a51:'비활성화',
	a52:'상태',
	a53:'이 계정을 삭제할 확실합니까?',
	a54:'복사되었습니다！',
	
	a55:'거래 매개변수를 입력해 주세요',
	a56:'새 비밀번호와 확인 비밀번호가 일치하지 않습니다!',
	a57:'일간 수익',
	a58:'평균',
	a59:'최대',
	a60:'새로고침 성공',
	a61:'생산성',
	a62:'미달',
	a63:'합격',
	a64:'승률',
	a65:'출금',
	a66:'입금',
	a67:'잔액',
	a68:'순가치',
	a69:'일간 수익/손실',
	a70:'수치를 입력해 주세요',
	a71:'이 신호에는 아직 동기화자 없습니다',
	a72:'로그인 상태가 만료되었습니다. 다시 로그인해 주세요!',
	a73:'SMS가 발송되었습니다. 확인하고 수신해 주세요.',
	a74:'인증 코드가 발송되었습니다!',
	a75:'로그인 성공입니다!',
	a76:'사용자 이름은 비워둘 수 없습니다',
	a77:'휴대폰 번호는 비워둘 수 없습니다',
	a78:'사용자 약관 및 개인정보 처리방침에 동의하지 않았습니다',
	a79:'회원 업그레이드',
	a80:'유형 선택',
	a81:'현재 유효기간까지',
	a82:'환산 유효기간까지',
	a83:'참고: 환산 후 유효기간은 시스템이 자동으로 계산하여 도출합니다.',
	a84:'파일을 여기에 드래그하세요',
	a85:'또는',
	a86:'클릭하여 업로드',
	a87:'귀하는 이미 최고 등급 회원이므로, 추가 업그레이드할 수 없습니다.',
	a88:'검토 중',
	a89:'이 결제 방식은 일시적으로 지원하지 않습니다',
	a90:'비밀번호 재설정',
	a91:'기억났어요',
	a92:'미국',
	a93:'중국',
	a94:'홍콩',
	
	a95:'위험 경고',
	a96:'본 지능형 양적 커뮤니티는 주로 표준화된 거래 신호를 제공하여 사용자가 참고하여 사용하도록 합니다.',
	a97:'전략 효과성을 보장하고 실행 편차를 통제하기 위해',
	a98:'단일 양적 대상의 자금 규모는 20000 USD 이상일 것을 권장합니다',
	a99:'투자 자금이 이 기준 미만인 경우, 자금 규모 부족으로 인해 상대적 위험이 확대되어 전략 안정성에 영향을 줄 수 있습니다.',
	a100:'어떠한 조작을 시작하기 전에, 반드시 본인의 재정 상황과 위험 감내 능력을 기준으로 해야 합니다.',
	a101:'계정의 위험 보호 메커니즘을 직접 설정하십시오.',
	a102:'모든 양적 거래 행위는 귀하의 개인 독립적 의사결정이며, 관련 이익과 손실 및 시장 변동, 시스템 고장, 정책 변경 등 불가항력 요인으로 인한 손실은',
	a103:'모두 귀하 본인이 부담합니다.',
	a104:'본 커뮤니티에서 제공하는 신호는 정보 참고용으로만 사용됩니다.',
	a105:'투자 조언, 제안 또는 보증으로 구성되지 않습니다.',
	a106:'본 지능형 양적 커뮤니티는',
	a107:'어떠한 거래 결과나 자금 손실에 대한 책임도 지지 않습니다.',
	a108:'위에 명시된 위험을 완전히 이해하고 수락을 확인한 후에 조작을 진행하십시오.',
	a109:'저는 이미 이해했습니다',
	
	zhlb:'계정 목록',
	
	a110:'아직 등급이 없음',
}
